import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { alpha, useTheme } from '@mui/material/styles';
import Popover from '@mui/material/Popover';
import { SimTypography } from 'components/SimTypography';
import Grid from '@mui/material/Grid';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { HashLink as Link } from 'react-router-hash-link';

const NavItem = ({ title, id, items, colorInvert = false }) => {
	const theme = useTheme();

	const [anchorEl, setAnchorEl] = useState(null);
	const [openedPopoverId, setOpenedPopoverId] = useState(null);

	const handleClick = (event, popoverId) => {
		setAnchorEl(event.target);
		setOpenedPopoverId(popoverId);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setOpenedPopoverId(null);
	};

	const [activeLink, setActiveLink] = useState('');
	useEffect(() => {
		setActiveLink(window && window.location ? window.location.pathname : '');
	}, []);

	const hasActiveLink = () => items.find(i => i.href === activeLink);
	const linkColor = colorInvert ? theme.palette.text.default : 'common.white';

	const [showHoverMenu, setshowHoverMenu] = useState('none');
	const [showHoverMenuChild, setshowHoverMenuChild] = useState('none');

	const [HoverListLength, setHoverListLength] = useState(0);

	return (
		<Box>
			<Box
				display={'flex'}
				alignItems={'center'}
				aria-describedby={id}
				sx={{ cursor: 'pointer' }}
				onClick={e => handleClick(e, id)}>
				<SimTypography
					fontWeight={openedPopoverId === id || hasActiveLink() ? 700 : 400}
					variant='menuRootText'
					color={linkColor}>
					{title}
				</SimTypography>
				<ExpandMoreIcon
					sx={{
						marginLeft: theme.spacing(1 / 4),
						width: 16,
						height: 16,
						transform: openedPopoverId === id ? 'rotate(180deg)' : 'none',
						color: linkColor
					}}
				/>
			</Box>
			<Popover
				elevation={10}
				id={id}
				open={openedPopoverId === id}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				sx={{
					'.MuiPaper-root': {
						maxWidth: items.length > 12 ? 550 : 450,
						minHeight: items.length * 46 + 13,
						height: items.length * 47 + HoverListLength * 47.8 + 10,
						marginBottom: 0,
						marginTop: 3,
						borderTopRightRadius: 0,
						borderTopLeftRadius: 0,
						borderBottomRightRadius: 12,
						borderBottomLeftRadius: 12,
						borderTop: `5px solid ${theme.palette.primary.main}`
					}
				}}>
				<Grid container spacing={0} bgcolor={theme.palette.background.default}>
					{items.map((p, i) => (
						<Grid
							item
							key={i}
							xs={items.length > 12 ? 6 : 12}
							borderBottom={1}
							borderColor={alpha(theme.palette.primary.main, 0.1)}
							sx={{
								backgroundColor:
									activeLink === p.href ? alpha(theme.palette.primary.main, 0.1) : 'transparent'
							}}>
							<Button
								component={'a'}
								href={p.href}
								fullWidth
								onMouseEnter={() => {
									setshowHoverMenu(p.title);
									p.showSections ? setHoverListLength(p.sections.length) : setHoverListLength(0);
								}}
								onMouseLeave={() => {
									setshowHoverMenu('none');
									showHoverMenu === 'none' && showHoverMenuChild === 'none'
										? setHoverListLength(1)
										: setHoverListLength(0);
								}}
								sx={{
									justifyContent: 'flex-start',
									paddingLeft: p.isTabLink === 1 ? 2 : 0,
									color:
										activeLink === p.href ? theme.palette.primary.main : theme.palette.text.primary,
									backgroundColor:
										activeLink === p.href ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
									fontWeight: activeLink === p.href ? 600 : 400
								}}>
								<Box paddingLeft={2}>{p.title}</Box>
							</Button>

							<Grid item xs={items.length > 12 ? 6 : 12}>
								{(showHoverMenu === p.title || showHoverMenuChild === p.title) && p.showSections
									? p.sections.map((p2, i2) => (
											<Box
												key={i2}
												position='relative'
												height='44.5px'
												paddingY={0}
												marginY={0}
												onMouseEnter={() => {
													setshowHoverMenuChild(p.title);
													p.showSections
														? setHoverListLength(p.sections.length)
														: setHoverListLength(0);
												}}
												onMouseLeave={() => {
													setshowHoverMenuChild('none');
													showHoverMenu === 'none' && showHoverMenuChild === 'none'
														? setHoverListLength(1)
														: setHoverListLength(0);
												}}>
												<Box
													position='absolute'
													width={'100%'}
													height='44.5px'
													margin={0}
													padding={0}>
													<Button
														key={i2}
														height='44.5px'
														margin={0}
														padding={0}
														component={'a'}
														fullWidth
														sx={{
															justifyContent: 'flex-start',
															color:
																activeLink === p2.sectionAnchorLink
																	? theme.palette.primary.main
																	: theme.palette.text.primary,
															backgroundColor:
																activeLink === p2.sectionAnchorLink
																	? alpha(theme.palette.primary.main, 0.1)
																	: 'transparent',
															fontWeight: activeLink === p2.sectionAnchorLink ? 600 : 400
														}}>
														<Box
															paddingLeft={0}
															marginTop={0}
															paddingTop={0}
															height='44.5px'
															display='flex'
															alignContent={'flex-start'}
															alignItems={'flex-start'}
															justifyContent={'left'}>
															<SimTypography
																variant={'p'}
																height='44.5px'
																marginTop={'-5px'}
																paddingLeft={2}>
																&#9658; {p2.sectionTitle}{' '}
															</SimTypography>
														</Box>
													</Button>
												</Box>

												<Box position='absolute' width={'100%'} height='40px'>
													<Link
														to={p2.sectionAnchorLink}
														activeStyle={{ textDecoration: 'none' }}>
														<Box width={'100%'} height='40px'></Box>
													</Link>
												</Box>
											</Box>
									  ))
									: null}
							</Grid>
						</Grid>
					))}
				</Grid>
			</Popover>
		</Box>
	);
};

NavItem.propTypes = {
	title: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired,
	colorInvert: PropTypes.bool
};

export default NavItem;
